import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PredesImpcCodeUsageNonComplianceReport
  from '../../components/PredesImpcCodeUsageNonComplianceReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesImpcCodeUsageNonComplianceDetailsSelectors';

export function PredesImpcCodeUsageNonComplianceDetailsContainer(props) {
  return (
    <PredesImpcCodeUsageNonComplianceReport
      reportId={ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesImpcCodeUsageNonComplianceDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesImpcCodeUsageNonComplianceDetailsContainer);
